/**
 * Sidebar/SetupMenu/SetupGroups/index.tsx
 * desc: the grouped configuration links of the Setup section — a label per group, text-only rows beneath
 * note: shared by the accordion and the flyout
 */

import { translate } from '../../../../utilities/localization';
import type { NavGroup } from '../../config';
import MenuItem from '../../MenuItem';

const SetupGroups = ({ groups }: { groups: NavGroup[] }) => (
    <>
        { groups.map((group) => (
            <div key={ group.id } className="group">
                <div className="group-label">{ translate(group.labelKey) }</div>
                { group.items.map((item) => <MenuItem key={ item.id } item={ item } isCollapsed={ false } variant="child"/>) }
            </div>
        )) }
    </>
);

export default SetupGroups;
